import React from "react";
import ExclamationIcon from "../../assets/img/exclamation-mark-icon.svg";
const DigilockerPopup = React.forwardRef((props, ref) => {
  const { showModalBox, record, title, description, isAdd, checkStatus, handleSaveData } = props;

  const closePopupHandler = (e) => {
    e.preventDefault();
    props.closePopup();
  };

  const proceedHandler = (e) => {
    e.preventDefault();
    // props.proceedHandler();
    props.handleSaveData(e);
  };

  return (
    <>
      <div className="dashboard custom-modal-dialog Education-modal show" id="empGap">
        <div className="modal-wrapper">
          <div
            className="modal-content p-4 no-scroll"
            style={{ overflow: "unset", maxHeight: "unset" , width:"434px" }}
          >
          <div>
            <h4>Education check via Digilocker</h4>
            <p>You will be redirected to DigiLocker page to fetch education documents please follow simple 5 steps</p>
            <ol class="p-3">
              <li>
                Sign in using your Aadhar number.</li>
                <li>Verify your identity with OTP.</li>
                <li>Login using your digilocker 6-digit PIN.</li>
                <li>Provide Consent for Document attachment.</li>
                <li>Redirect back to iBridge Application.</li>
            </ol>
            <h6 class="fnt-16 text-primary">Not found your education document on Digilocker?</h6>
            <p class="fnt-12 text-gray text-justify">* If your university or board is not currently listed on DigiLocker or Your Degree/marksheets not fetched via DigiLocker, don't worry! This wont impact your verification.</p>
          </div> 

          
            <div class="row">
              <div class="col-12">
                <button
                  className="btn btn-primary btn-lg btn-block" onClick={(e) => {proceedHandler(e)}}>
                  Continue
                </button>
                <button
                  className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2" onClick={(e) => {closePopupHandler(e)}}>
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default DigilockerPopup;
